import React from 'react';

const timeFormatter = (created_at) => {
    let unix = Math.round(+new Date() / 1000);
    let diff = unix - created_at;
    if (diff <= 60)
        return 'less than 0 min ago';
    if (diff <= 3600)
        return `${Math.round(diff / 60)} min ago`;
    if (diff <= 86400)
        return `${Math.round(diff / 3600)} hours ago`;
    if (diff <= 31536000)
        return `${Math.round(diff / 86400)} days ago`;
    return 'more then 1 year ago';
};

const Twitter = (props) => {
    const {name, screen_name, created_at, text, profile_image_url} = props;
    return (
        <div className="twitter">
            <div className="content">
                <div className="stream-item-header">
                    <img className="avatar js-action-profile-avatar"
                         src={profile_image_url} alt=""/>
                    <div className="stream-item-header-content">
                        <span className="FullNameGroup">
                          <strong className="fullname show-popup-with-id u-textTruncate"
                                  data-aria-label-part="">{name}</strong><span>‏</span>
                            <span className="UserNameBreak">&nbsp;</span>
                         </span>
                        <span className="username u-dir u-textTruncate">@<b>{screen_name}</b></span>
                        <small className="time">
                            <span className="_timestamp js-short-timestamp js-relative-timestamp" data-long-form="true"
                                  aria-hidden="true">{timeFormatter(created_at)}</span>
                        </small>
                        <div className="js-tweet-text-container">
                            <p className="TweetTextSize  js-tweet-text tweet-text" lang="ja"
                               data-aria-label-part="0">{text}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Twitter;
